@use "../colors.scss" as *;

/* stylelint-disable */
:export {
  background: $color-secondary-black;
  sub-background: $color-action-text-dark;
  slider-background: $color-secondary-black;
  borders: $color-grey-A;
  emphasis-text: $color-action-text-light;
  text: $color-grey-D;
  sub-text: $color-grey-sub-text;
  light-text: $color-grey-C;
  readonly-field-text: $color-grey-sub-text;
  header: $color-grey-D;
  links: $color-hyperlink-B;
  hover: $color-hover;
  focus: $color-primary-purple-hover;
  shadow: $color-container-shadow-A;
  deepest: $color-action-background-dark;
  primary: $color-primary-purple;
  secondary: $color-primary-purple;
  header-footer: $color-action-text-dark;
  input-readonly: $color-action-text-dark;
  input-readonly-border: $color-grey-A;
  tooltip: $color-grey-B;
  info-hover: $color-black-info-hover;
  info-active: $color-primary-black;
  placeholder-text-color: $color-grey-B;
  icon: $color-grey-C;
  radio-disabled-background: $color-grey-A;

  // Oddities
  sidebar: $color-secondary-black;
  table-header-background: $color-action-text-dark;
  table-border: $color-grey-A;
  table-text: $color-grey-D;
  table-disabled-text: $color-grey-disabled;
  table-header-disabled-background: $color-tag-font;
  table-cell-disabled-background: $color-state-dark-background;
  table-hover: $color-gray-table-hover;
  secondary-button-hover: $color-grey-A;
  dark-secondary-button-hover: $color-state-dark-background;
  secondary-button-active: $color-primary-black;
  secondary-button-disabled: $color-grey-A;
  grid-color: $color-grey-B;
  secondary-button-border: $color-grey-A;
  divider: $color-grey-A;
  secondary-button-background: $color-action-text-dark;
  secondary-links: $color-hyperlink-B;
  info-alert-background: $color-action-text-dark;
  info-alert-border: $color-grey-B;
  form-control-border: $color-grey-B;
  form-alert-info-icon: $color-grey-C;
  placeholder-text-color: $color-grey-B;
  table-column-selected: $color-secondary-green-hover-10-solid;
  header-label-text-color: $color-grey-disabled;
  slider-radio-button-background: $color-secondary-black;

  // checkbox
  checkbox-border: $color-grey-A;
  checkbox-hover-border: $color-grey-C;
  checkbox-checked-background: $color-primary-purple;
  checkbox-checked-hover-background: $color-hyperlink-B;
  checkbox-disabled-checked-background: $color-grey-A;
  checkbox-disabled-border: $color-grey-A;

  // tabs
  tab-label-selected: $color-grey-D;
  tab-label-unselected: $color-grey-disabled;
  tab-label-hover: $color-grey-D;

  // dropdown
  dropdown-selected-outline-color: $color-hyperlink-B;
  hover-focus-shadow: $color-focus-shadow;
  dropdown-selected-value-color: $color-secondary-black;
  dropdown-background-color: $color-action-text-dark;
  dropdown-selected-outline-color: $color-hyperlink-B;
  dropdown-text: $color-grey-D;
  dropdown-borders-color: $color-grey-B;
  dropdown-item-hover: $color-black-info-hover;
  dropdown-selected-background-color: $color-selected-background;
  dropdown-checked-icon-color: $color-hyperlink-B;
  dropdown-hover-background: $color-secondary-black;
  checkbox-hover-shadow: $color-selected-background;

  // draggable list
  draggable-list-item-border: $color-grey-A;
  draggable-list-selected-background: $color-selected-background;

  // button
  invisi-clear-button-color: $color-transparent;
  invisi-clear-button-active-color: $color-secondary-black;
  button-delete-active-background: $color-primary-black;
  button-delete-danger-color: $color-alert-red-border;
  button-remove-chip: $color-grey-B;
  button-toggle-hover: $color-grey-A-fade;

  // statuschip
  status-chip-inprogress: $color-transparent;
  status-chip-ignore-background: $color-grey-B-10;
  status-chip-fail-border: $color-primary-red-10;
  status-chip-fail-background: $color-primary-red-20;
  status-chip-pass-border: $color-secondary-green-80;
  status-chip-cancelled-border: $color-grey-light-text;
  status-chip-error-border: $color-warning-orange-80;

  //test config tags
  color-tag-background: $color-tag-secondary-backgrond;
  color-tag-font: $color-grey-D;
  status-chip-text-color: $color-white;

  //id
  id: $color-grey-D;

  //runtypebadge
  run-type-badge-background-color: $color-tag-font;

  // dialog box
  dialog-box-shadow: none;

  // FormAlert color pair
  color-info: $color-primary-purple-10;
  color-success: $color-secondary-green-hover-10;
  color-warning: $color-warning-orange-10;
  color-error: $color-primary-red-10;
  color-tip: $color-secondary-blue-10;
  color-info-border: $color-primary-purple;
  color-success-border: $color-secondary-green;
  color-warning-border: $color-warning-orange;
  color-error-border: $color-primary-red;
  color-tip-border: $color-secondary-blue;
  color-info-icon: $color-primary-purple-light;
  color-success-icon: $color-secondary-green;
  color-warning-icon: $color-warning-orange;
  color-error-icon: $color-highlight-red;
  color-tip-icon: $color-primary-blue-light;

  color-error-placeholder-background: $color-primary-red-20;

  // drag and drop box
  drag-and-drop-box-on-drag-color: $color-primary-purple-50;
  drag-and-drop-box-icon-color: $color-primary-purple;

  color-dnd-icon: $color-grey-B;

  // progress flow
  progress-flow-background-color: $color-state-dark-background;
  progress-flow-text-color: $color-grey-D;

  // badge
  badge-default-color: $color-primary-purple-30;
  badge-hover-color: $color-primary-purple-45;
  badge-active-color: $color-primary-purple-60;
  badge-background-color: $color-grey-badge-background;
  badge-test-case-text: $color-grey-C;
  badge-tag-background-color: rgba($color-primary-purple, 0.1);

  // test case step
  test-case-global-icon-color: $color-hyperlink-B;

  // logs
  log-row-background-initializing: $color-table-log-background-secondary-initializing;
  log-row-background-error: $color-table-log-background-secondary-error;
  log-row-background-success: $color-table-log-background-secondary-success;
  log-row-background-orange: $color-warning-orange-10;
  log-text-initializing: $color-table-log-text-secondary-initializing;
  log-text-error: $color-table-log-text-secondary-error;
  log-text-success: $color-table-log-text-secondary-success;
  log-text-orange: $color-warning-orange;

  // test case tag
  test-case-tag-color: $color-primary-purple-10;

  // notifications event
  notification-events-border: $color-grey-A;

  // test config log
  test-config-log-message-background: $color-gray-table-hover;
  
  // stop icon
  stop-icon-color: $color-table-log-text-secondary-error;

  // alert background color
  information-background-color: $color-purple-form-alert-dark-background;
  information-external-background-color: $color-hyperlink-C;
}

/* stylelint-enable */

html,
body {
  background: var(--background);
}